

export interface IBusDestination {
    id: number,
    name: string,
    description: string,
    destinationOption: string,
    isActive: boolean,    


    // this props is just for manage fee per school year. 
    // normally we can have this as independent interface. it is just because it is use in action of bus destination.

    schoolYearId: number,
    defaultArrivalWeeklyFee: number,
    defaultArrivalMonthlyFee: number,
    defaultArrivalQuarterlyFee: number,
    defaultArrivalQuarterlyLongFee: number,
    defaultArrivalQuarterlyShortFee: number,
    defaultArrivalYearlyFee: number,
    defaultDepartureWeeklyFee: number,
    defaultDepartureMonthlyFee: number,
    defaultDepartureQuarterlyFee: number,
    defaultDepartureQuarterlyLongFee: number,
    defaultDepartureQuarterlyShortFee: number,
    defaultDepartureYearlyFee: number,
    defaultRoundTripWeeklyFee: number,
    defaultRoundTripMonthlyFee: number,
    defaultRoundTripQuarterlyFee: number,
    defaultRoundTripQuarterlyLongFee: number,
    defaultRoundTripQuarterlyShortFee: number,
    defaultRoundTripYearlyFee: number,
  }


  


  export const defaultBusDestination : IBusDestination = {
    id: 0,
    name: '',
    description: '',
    destinationOption: '',
    isActive: true,   


    schoolYearId: 0,

    defaultArrivalWeeklyFee: 0,
    defaultArrivalMonthlyFee: 0,
    defaultArrivalQuarterlyFee: 0,
    defaultArrivalQuarterlyLongFee: 0,
    defaultArrivalQuarterlyShortFee: 0,
    defaultArrivalYearlyFee: 0,
    defaultDepartureWeeklyFee: 0,
    defaultDepartureMonthlyFee: 0,
    defaultDepartureQuarterlyFee: 0,
    defaultDepartureQuarterlyLongFee: 0,
    defaultDepartureQuarterlyShortFee: 0,
    defaultDepartureYearlyFee: 0,
    defaultRoundTripWeeklyFee: 0,
    defaultRoundTripMonthlyFee: 0,
    defaultRoundTripQuarterlyFee: 0,
    defaultRoundTripQuarterlyLongFee: 0,
    defaultRoundTripQuarterlyShortFee: 0,
    defaultRoundTripYearlyFee: 0,
  }

  export interface IBusDestinationSearch {   
    name: string,
    description: string,
    destinationOption: string,
  }
  